export default __webpack_public_path__ + "static/date-label-do-2-light-0793f7f69b34b8c59f5176eb020d7099ed809c7fd5ca97e71aa2c5ff51911c7e.png";